export const DELETED_USER_DISPLAY_NAME = "삭제된 유저";

export type UserNamesMap = Record<string, string | null>;

/** 맵이 로드된 뒤 키가 없으면 삭제된 유저로 판단한다. 로딩 중(undefined)엔 false. */
export const isDeletedUser = (
  userNamesMap: UserNamesMap | undefined,
  email: string,
) => {
  if (!userNamesMap) return false;

  return !Object.prototype.hasOwnProperty.call(userNamesMap, email);
};

/**
 * 이름을 모르는 사용자의 표시값 — 이메일 도메인(@ 뒤)은 노출하지 않는다.
 * 로컬파트가 없는 비정상 입력(`@only.com`)은 자르지 않고 원문을 돌려준다 — 빈 이름보다 낫다.
 */
export const getEmailDisplayName = (email: string) =>
  email.split("@")[0] || email;

/**
 * 로딩 중이면 undefined — 스켈레톤으로 갈아끼울 화면이 쓴다.
 * 로딩 구분 없이 항상 이름이 필요하면 getAuthorDisplayName을 쓸 것.
 */
export const getUserDisplayName = (
  userNamesMap: UserNamesMap | undefined,
  email: string,
) => {
  if (!userNamesMap) return undefined;
  if (isDeletedUser(userNamesMap, email)) return DELETED_USER_DISPLAY_NAME;

  const name = userNamesMap[email];
  if (name === null) return getEmailDisplayName(email);

  return name.trim() || getEmailDisplayName(email);
};

/**
 * 작성자 이름을 그리는 지점 전용 — 로딩 중에도 항상 그릴 이름을 돌려준다.
 * 폴백을 호출부가 각자 조립하면(`?? email`, `?? email.split("@")[0]` …) 같은 사람이
 * 화면마다 다른 이름으로 보인다. WXBRL-2317이 딱 그 형태였으므로 여기로 모은다.
 */
export const getAuthorDisplayName = (
  userNamesMap: UserNamesMap | undefined,
  email: string,
) => getUserDisplayName(userNamesMap, email) ?? getEmailDisplayName(email);
